import ChatBot from "react-simple-chatbot";
import { ThemeProvider } from "styled-components";
import bot from "../../assets/bot.png";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { postFetch, processApiError } from "../../utils/api";
import { toast } from "react-toastify";

const Chatbot = () => {
  const [form, setForm] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    companySize: "",
    phoneNo: "",
    message: "",
  });

  const handleSubmit = async () => {
    const payload = {
      firstname: form.firstName,
      lastname: form.lastName,
      email: form.email,
      companyname: form.companyName,
      companysize: form.companySize,
      phonenumber: form.phoneNo,
      description: form.message,
    };

    try {
      const { data, response } = await postFetch("account/book-demo/", payload);
      if (response.ok) {
        setForm({
          firstName: "",
          lastName: "",
          email: "",
          companyName: "",
          companySize: "",
          phoneNo: "",
          message: "",
        });
      } else {
        toast.error(processApiError(data) || "Error occurred");
      }
    } catch (error) {
      console.log("handleSubmit", error);
    }
  };

  useEffect(() => {
    if (form.message !== "") {
      handleSubmit();
    }
  }, [form]);

  const theme = {
    background: "#fff",
    fontFamily: "Montserrat",
    headerBgColor: "#3c1d7a",
    headerFontColor: "#fff",
    headerFontSize: "15px",
    botBubbleColor: "#3c1d7a",
    botFontColor: "#fff",
    userBubbleColor: "#fff",
    userFontColor: "rgb(74, 74, 74)",
  };

  const employeebenifit = (
    <div class="sc-dnqmqq efROPc rsc-ts rsc-ts-bot">
      <div class="sc-htoDjs vmYlS rsc-ts-image-container">
        <img
          class="sc-gzVnrw cwuCQv rsc-ts-image"
          src="data:image/png;base64,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"
          alt="avatar"
        />
      </div>
      <div class="sc-bZQynM gCJGqL rsc-ts-bubble">
        Thank you for your interest! Please{" "}
        <Link
          style={{ textDecoration: "underline", color: "#fff" }}
          to="/products/employee-benefits"
        >
          click here
        </Link>{" "}
        to learn more about how we can assist you with this use case. 🌟
      </div>
    </div>
  );

  const expanceManagement = (
    <div class="sc-dnqmqq efROPc rsc-ts rsc-ts-bot">
      <div class="sc-htoDjs vmYlS rsc-ts-image-container">
        <img
          class="sc-gzVnrw cwuCQv rsc-ts-image"
          src="data:image/png;base64,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"
          alt="avatar"
        />
      </div>
      <div class="sc-bZQynM gCJGqL rsc-ts-bubble">
        Thank you for your interest! Please{" "}
        <Link
          style={{ textDecoration: "underline", color: "#fff" }}
          to="/products/expense-management"
        >
          click here
        </Link>{" "}
        to learn more about how we can assist you with this use case. 🌟
      </div>
    </div>
  );

  const payroolSol = (
    <div class="sc-dnqmqq efROPc rsc-ts rsc-ts-bot">
      <div class="sc-htoDjs vmYlS rsc-ts-image-container">
        <img
          class="sc-gzVnrw cwuCQv rsc-ts-image"
          src="data:image/png;base64,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"
          alt="avatar"
        />
      </div>
      <div class="sc-bZQynM gCJGqL rsc-ts-bubble">
        Thank you for your interest! Please{" "}
        <Link
          style={{ textDecoration: "underline", color: "#fff" }}
          to="/products/payroll"
        >
          click here
        </Link>{" "}
        to learn more about how we can assist you with this use case. 🌟
      </div>
    </div>
  );

  const privacy = (
    <div class="sc-dnqmqq efROPc rsc-ts rsc-ts-bot">
      <div class="sc-htoDjs vmYlS rsc-ts-image-container">
        <img
          class="sc-gzVnrw cwuCQv rsc-ts-image"
          src="data:image/png;base64,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"
          alt="avatar"
        />
      </div>
      <div class="sc-bZQynM gCJGqL rsc-ts-bubble">
        "Awesome! Before we proceed, I want to assure you that your privacy is
        important to us. For more details, please read our{" "}
        <Link
          style={{ textDecoration: "underline", color: "#fff" }}
          to="/privacy-policy"
        >
          privacy policy
        </Link>{" "}
        🔒
      </div>
    </div>
  );

  const steps = [
    {
      id: "1",
      message:
        "Hello! 👋 I'm Ashva, your virtual assistant from Vergado. I'm here to help you with anything related to employee finance. How can I assist you today?",
      trigger: "options",
    },
    {
      id: "options",
      options: [
        {
          value: "howVergadoWorks",
          label: "🔍 I want to see how Vergado works.",
          trigger: "howVergadoWorks",
        },
        {
          value: "transformFinance",
          label: "🚀 I am looking to transform my company's employee finance.",
          trigger: "transformFinance",
        },
        {
          value: "workWithVergado",
          label: "💼 I would love to work with Vergado.",
          trigger: "workWithVergado",
        },
        {
          value: "question",
          label: "❓ I have a question.",
          trigger: "question",
        },
      ],
    },
    {
      id: "howVergadoWorks",
      component: privacy,
      trigger: "getWorkEmail",
    },
    {
      id: "getWorkEmail",
      message:
        "Let's get started step by step. First, I need your work email. 📧",
      trigger: "userWorkEmail",
    },
    {
      id: "userWorkEmail",
      user: true,
      trigger: ({ value }) => {
        setForm((prevState) => ({ ...prevState, email: value }));
        return "getFirstName";
      },
    },
    {
      id: "getFirstName",
      message: "Thanks! Now, can I have your first name? 😊",
      trigger: "userFirstName",
    },
    {
      id: "userFirstName",
      user: true,
      trigger: ({ value }) => {
        setForm((prevState) => ({ ...prevState, firstName: value }));
        return "getLastName";
      },
    },
    {
      id: "getLastName",
      message: "Great, and your last name? 🌟",
      trigger: "userLastName",
    },
    {
      id: "userLastName",
      user: true,
      trigger: ({ value }) => {
        setForm((prevState) => ({ ...prevState, lastName: value }));
        return "getCompanyName";
      },
    },
    {
      id: "getCompanyName",
      message: "Almost there! What's your company name? 🏢",
      trigger: "userCompanyName",
    },
    {
      id: "userCompanyName",
      user: true,
      trigger: ({ value }) => {
        setForm((prevState) => ({ ...prevState, companyName: value }));
        return "getCompanySize";
      },
    },
    {
      id: "getCompanySize",
      message: "Thanks! How big is your company? 👥",
      trigger: "userCompanySize",
    },
    {
      id: "userCompanySize",
      user: true,
      trigger: ({ value }) => {
        setForm((prevState) => ({ ...prevState, companySize: value }));
        return "getPhoneNumber";
      },
    },
    {
      id: "getPhoneNumber",
      message: "Just a couple more details. What's your phone number? 📞",
      trigger: "userPhoneNumber",
    },
    {
      id: "userPhoneNumber",
      user: true,
      trigger: ({ value }) => {
        setForm((prevState) => ({ ...prevState, phoneNo: value }));
        return "additionalRemarks";
      },
    },
    {
      id: "additionalRemarks",
      message: "Lastly, do you have any additional remarks? 📝",
      trigger: "userRemarks",
    },
    {
      id: "userRemarks",
      user: true,
      trigger: ({ value }) => {
        setForm((prevState) => ({ ...prevState, message: value }));
        return "thankYou";
      },
    },
    {
      id: "thankYou",
      message:
        "Thank you for providing the details! One of our representatives will get in touch with you soon to show you how Vergado works in action. 🎉",
      trigger: "askMore",
    },
    {
      id: "transformFinance",
      message: "Great! We can help you with the following use cases:",
      trigger: "transformFinanceOptions",
    },
    {
      id: "transformFinanceOptions",
      options: [
        {
          value: "employeeBenefits",
          label: "💰 Employee benefits program",
          trigger: "employeeBenefits",
        },
        {
          value: "expenseManagement",
          label: "💼 Expense Management Platform",
          trigger: "expenseManagement",
        },
        {
          value: "payrollSolutions",
          label: "📝 Payroll solutions",
          trigger: "payrollSolutions",
        },
      ],
    },
    {
      id: "employeeBenefits",
      component: employeebenifit,
      trigger: "askMore",
    },
    {
      id: "askMore",
      options: [
        {
          value: "askMore",
          label: "Ask More",
          trigger: "options",
        },
      ],
    },
    {
      id: "expenseManagement",
      component: expanceManagement,
      trigger: "askMore",
    },
    {
      id: "payrollSolutions",
      component: payroolSol,
      trigger: "askMore",
    },
    {
      id: "workWithVergado",
      message:
        "That's great because we are hiring! 🎉 Please forward your CV to hr@vergado.in. We look forward to hearing from you. 🤝",
      trigger: "askMore",
    },
    {
      id: "question",
      message:
        "No problem! Please send your queries to support@vergado.in, and our support team will get back to you as soon as possible. 📧",
      trigger: "askMore",
    },
  ];

  return (
    <>
      <ThemeProvider theme={theme}>
        <ChatBot
          floating={true}
          steps={steps}
          botDelay={1000}
          headerTitle="Ashva"
          botAvatar={bot}
        />
      </ThemeProvider>
    </>
  );
};

export default Chatbot;
